import NonCriticalError from '@/errors/NonCriticalError.js';

class UnauthorizedError extends NonCriticalError {
}

export default UnauthorizedError;
